import React, { useEffect, useState } from 'react';
import { fetchConnectedSources, fetchSourceFiles } from '../services/demoExtrasService';

function formatTimeAgo(iso) {
  try {
    const ms = Date.now() - new Date(iso).getTime();
    const m = Math.round(ms / 60000);
    if (m < 1) return 'just now';
    if (m < 60) return `${m}m ago`;
    const h = Math.round(m / 60);
    if (h < 24) return `${h}h ago`;
    return `${Math.round(h / 24)}d ago`;
  } catch { return iso; }
}

const TYPE_BADGES = {
  gis:        { color: '#2563eb', label: 'GIS' },
  sql:        { color: '#0891b2', label: 'SQL' },
  databricks: { color: '#dc2626', label: 'DB' },
  onedrive:   { color: '#0ea5e9', label: 'OD' },
  sharepoint: { color: '#0369a1', label: 'SP' }
};

export default function ConnectedSourcesPanel() {
  const [sources, setSources] = useState([]);
  const [active, setActive] = useState(null);
  const [files, setFiles] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    fetchConnectedSources().then((d) => { setSources(d); setLoading(false); });
  }, []);

  const open = async (s) => {
    setActive(s);
    setFiles([]);
    const f = await fetchSourceFiles(s.id);
    setFiles(f);
  };

  return (
    <div style={{ padding: 12, height: '100%', overflowY: 'auto', background: 'transparent' }}>
      <div style={{ fontSize: 11, color: '#94a3b8', textTransform: 'uppercase', letterSpacing: '0.05em', fontWeight: 600, marginBottom: 8 }}>
        Connected Sources
      </div>
      {loading ? (
        <div style={{ color: '#94a3b8', fontSize: 12 }}>Connecting…</div>
      ) : (
        <div style={{ display: 'flex', flexDirection: 'column', gap: 6 }}>
          {sources.map((s) => {
            const badge = TYPE_BADGES[s.id] || { color: '#64748b', label: '?' };
            return (
              <div
                key={s.id}
                onClick={() => open(s)}
                style={{
                  display: 'flex', alignItems: 'center', gap: 10,
                  padding: '8px 10px',
                  background: active?.id === s.id ? 'rgba(37,99,235,0.18)' : 'rgba(15,23,42,0.45)',
                  border: '1px solid ' + (active?.id === s.id ? '#2563eb' : 'rgba(148,163,184,0.18)'),
                  borderRadius: 6, cursor: 'pointer', transition: 'background 120ms'
                }}
              >
                <div style={{
                  width: 28, height: 28, borderRadius: 6,
                  background: badge.color + '33',
                  color: badge.color,
                  display: 'flex', alignItems: 'center', justifyContent: 'center',
                  fontWeight: 700, fontSize: 11
                }}>{badge.label}</div>
                <div style={{ flex: 1, minWidth: 0 }}>
                  <div style={{ fontSize: 12, color: '#e2e8f0', fontWeight: 500, whiteSpace: 'nowrap', overflow: 'hidden', textOverflow: 'ellipsis' }}>{s.name}</div>
                  <div style={{ fontSize: 10, color: '#94a3b8' }}>
                    {s.layers ? `${s.layers} layers` : s.tables ? `${s.tables} tables` : s.files ? `${s.files} files` : s.lists ? `${s.lists} lists` : s.type}
                    {s.records_synced ? ` · ${s.records_synced.toLocaleString()} rows` : ''}
                  </div>
                  <div style={{ fontSize: 10, color: '#64748b', marginTop: 1 }}>
                    {s.last_sync ? `Synced ${formatTimeAgo(s.last_sync)} · ${s.latency_ms}ms` : `${s.latency_ms}ms`}
                  </div>
                </div>
                <span style={{ width: 8, height: 8, borderRadius: '50%', background: '#16a34a', boxShadow: '0 0 6px #16a34a', flex: '0 0 8px' }} />
              </div>
            );
          })}
        </div>
      )}

      {active && (
        <div style={{ marginTop: 14, padding: 10, background: 'rgba(15,23,42,0.6)', border: '1px solid rgba(148,163,184,0.2)', borderRadius: 6 }}>
          <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: 8 }}>
            <div style={{ fontSize: 11, fontWeight: 600, color: '#e2e8f0' }}>{active.name}</div>
            <button onClick={() => setActive(null)} style={{ background: 'transparent', color: '#94a3b8', border: 'none', cursor: 'pointer', fontSize: 14 }}>×</button>
          </div>
          {files.length === 0 ? (
            <div style={{ color: '#94a3b8', fontSize: 11 }}>Loading inventory…</div>
          ) : (
            <ul style={{ listStyle: 'none', padding: 0, margin: 0, display: 'flex', flexDirection: 'column', gap: 4 }}>
              {files.map((f, i) => (
                <li key={i} style={{ fontSize: 11, color: '#cbd5e1', padding: '4px 6px', background: 'rgba(148,163,184,0.08)', borderRadius: 4 }}>
                  <div style={{ color: '#e2e8f0' }}>{f.name}</div>
                  <div style={{ color: '#94a3b8', fontSize: 10, marginTop: 2 }}>
                    {f.type ? `${f.type} · ` : ''}{f.size || (f.rows != null ? `${f.rows} rows` : '') || (f.features != null ? `${f.features} features` : '') || (f.items != null ? `${f.items} items` : '')}
                    {f.modified ? ` · ${f.modified}` : ''}{f.owner ? ` · ${f.owner}` : ''}
                  </div>
                </li>
              ))}
            </ul>
          )}
        </div>
      )}
    </div>
  );
}
